import { ComponentProps, FC } from 'react';
import {
  CircularProgress,
  CircularProgressLabel,
  ResponsiveValue,
  Stack,
} from '@chakra-ui/react';

import Text from 'components/_core/Text';

interface AccountSetupCircularProgressProps {
  progress: number;
  progressLabel: string;
  size?: string;
  textSize?: ResponsiveValue<'sm' | 'md' | 'lg' | 'xs'>;
  textWeight?: ComponentProps<typeof Text>['fontWeight'];
  trackColor?: ComponentProps<typeof CircularProgress>['trackColor'];
}

const AccountSetupCircularProgress: FC<AccountSetupCircularProgressProps> = ({
  progress,
  progressLabel,
  size = '56px',
  textSize = 'md',
  textWeight = 'weight-500',
  trackColor = 'grey.200',
}) => {
  return (
    <CircularProgress
      capIsRound
      color="grey.800"
      size={size}
      thickness="6px"
      trackColor={trackColor}
      value={progress === 0 ? 5 : progress}
    >
      <CircularProgressLabel>
        <Stack alignItems="center">
          <Text fontWeight={textWeight} size={textSize} variant="primary">
            {progressLabel}
          </Text>
        </Stack>
      </CircularProgressLabel>
    </CircularProgress>
  );
};

export default AccountSetupCircularProgress;
